import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { MessageTypeEnum } from "../../../enums";
import confirmService from "../../common/confirmService";
import { Localization } from "../../common/Localization";
import { Renderers } from "../../common/GridRowRenderer";

class VyberDodavekDialogContent extends Component {
    state = {
        selectedDodavka: null
    };

    zvolitDodavku = async () => {
        var localizationService = provideLocalizationService(this);

        if (!this.state.selectedDodavka) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString("PríjemVýberDod.Vyberte dodávku zo zoznamu !", "Vyberte dodávku zo zoznamu !")
            });
            return;
        }
        this.props.zvolitDodavku(this.state.selectedDodavka);
        this.props.toggleDialog();
    };

    gridRowEventHandler = (eventType, dataItem) => {
        if (eventType === "onDoubleClick") {
            this.zvolitDodavku();
        }
    };

    render() {
        var renderers = new Renderers();

        return (
            <div id="VyberDodavekDialog" onMouseDown={e => e.preventDefault() /* prevents browser text selection */}>
                <Grid
                    data={this.props.dodavky.map(item => ({ ...item, selected: item.idDodavka === this.state.selectedDodavka }))}
                    selectedField="selected"
                    onRowClick={e => {
                        this.setState({
                            selectedDodavka: e.dataItem.idDodavka
                        });
                    }}
                    rowRender={(trElement, dataItem) => renderers.rowRender(trElement, dataItem, this.gridRowEventHandler)}>
                    <GridColumn field="expedovane" title="Expedované" format="{0:d.M.yyyy}" />
                    <GridColumn field="odesilatel" title="Odosielatel" />
                    <GridColumn field="cisloDodavky" title="Dodávka" />
                    <GridColumn field="doprava" title="Doprava" />
                    <GridColumn field="balikovALotov" title="Balíkov a lotov" />
                    <GridColumn field="pocetKs" title="Počet ks" />
                </Grid>
                <div className="button-bar">
                    <Button disabled={!this.state.selectedDodavka} icon="check" onClick={this.zvolitDodavku}>
                        <Localization messageKey={"PríjemVýberDod.Priradiť balík k dodávke"} defaultMessage={"Priradiť balík k dodávke"} />
                    </Button>
                </div>
            </div>
        );
    }
}

export default VyberDodavekDialogContent;

registerForLocalization(VyberDodavekDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijomDodavok/VyberDodavekDialogContent.js